import React, { useEffect, useContext, useState } from "react"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { JourneyContext } from "../../context/journeyContext"
import styled from "styled-components"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import ComponentReadMore from "../componentReadMore"
import { getValueFromJourney } from "../../services/helperFunctions"
import { lineCapital } from "../../../shared/functions"
import Parser from 'html-react-parser';
import "swiper/swiper.min.css"
import "swiper/components/navigation/navigation.min.css"
import SwiperCore, { Navigation } from "swiper/core"
SwiperCore.use([Navigation])

let selectors = [
  'myBtn',
  'myBtn1',
  'myBtn2'
]

const radioCardFormControlKey = [
  "CPCustomizePlanQuestionOne",
  "iSelect360CPCustomizePlanQuestionOne",
  "CPChooseYourPlan",
  "CPOptionInBuilt",
  'CPSpouseOptionBuilt',
  "FlexiCPPlanOption",
  "InvestmentPlanOption",
  "FutureDollarInvestmentPlanOption",
  "Invest4gInvestmentPlanOption",
  "guaranteedFortunePlanOption"
]

const tabFormControlKey = ["CPChooseYourPlan"]
const carouselFormControlKey = ["CPCustomizePlanQuestionOne", "iSelect360CPCustomizePlanQuestionOne", "FlexiCPPlanOption", "InvestmentPlanOption", "FutureDollarInvestmentPlanOption", "Invest4gInvestmentPlanOption", "guaranteedFortunePlanOption"]

const breakpoints = length => ({
  // when window width is <= 1023px
  1023: {
    slidesPerView: length,
    allowSlideNext: false,
    allowSlidePrev: false,
  },
  // when window width is <= 767px
  767: {
    slidesPerView: 1,
    allowSlideNext: true,
    allowSlidePrev: true,
  },
})

const RadioContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    & > .radio-label{
      text-align: center;
    }
  }

  .card {
    border-radius: 1rem;
    padding: 2rem;
    border-radius: 15px;
    background-color: #fff;
    position: relative;
    margin: 0px;
    margin-bottom: 0px;
    text-align: center;
    /* height: 178px; */
    margin-top: 0px;
    box-shadow: 0px 0px 20px #ccc;
    transition: all 200ms;
    min-height: 26rem;
  }
  .card-invest4g{
    min-height:31rem;
  }
  .card-guaranteedFurtunePlan{
    min-height:20rem;
  }

  /*Check tick start  */
  .checked{
    background: #ededed;
    color: #ededed;
    position: absolute;
    left: 2rem;
    top: 2rem;
    height: 3rem;
    width: 3rem;
    border-radius: 50%;
    padding: 5px;
    &>*{
      font-size: 1.2rem;
    }
  }
    
  input:checked ~ .card .checked{
    background: #fff;
    color: #3e505d;
  }
  /*Check tick end */


  .icon-container{
    /* font-size: 3rem; */
    /* padding: 1rem; */
    span{
      /* border-radius: 50%;
      padding: 1rem; */
      
      /* background: #3e505d; */
      .hero-icon{
        /* padding-top: 8px;
        color: #fff; */
        div{
        }
      }
    }
  }

  .card-title{
    font-size:1.8rem;
    margin: 1rem 0;
  }

  input:checked ~ .card{
    background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#3e505d" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"};
    background: var(--lumiq-card-bg);
    color: #fff;
    .icon-container-1{
      span{
        /* background: #fff ; */
        .hero-icon{
          /* color: #3e505d; */
          div{
            background-position-y: -92px;
          }
        }
      }
    }
    .readMoreContainer{
      color:"white"
    }
  }

  input:not(:checked) ~ .card{
    opacity: 0.5;

    .readMoreContainer{    color: #505050;}
  }
  @media screen and (max-width:1400px){
    .card-invest4g{
      min-height:33rem;
    }
  }
  @media screen and (max-width:1260px){
    .card{
      min-height:38rem;
    }
    .card-invest4g{
      min-height:43rem;
    }
    .card-guaranteedFurtunePlan{
      min-height:20rem;
    }
  }
  @media screen and (max-width:991px){
    .card-invest4g{
      min-height:20rem;
    }
  }
  @media screen and (max-width:767px){
    .card{
      min-height:10rem;
    }
  }
`

export default function StapiComponentTextSimpleRadioGroup(props) {
  const [activeTab, setActiveTab] = useState(props.data.radioComponent[0].name)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [options, setOptions] = useState({})

  let arr = {}

  useEffect(() => {
    if (Object.keys(sectionState.sectionData).length > 0) {
      if (sectionState.sectionData[props.data.formControlKey] && (props.data.formControlKey === "CPCustomizePlanQuestionOne"
        || props.data.formControlKey === "iSelect360CPCustomizePlanQuestionOne"
        || props.data.formControlKey === "FlexiCPPlanOption" || props.data.formControlKey === "guaranteedFortunePlanOption" )) {
        let currentRadio = document
          .getElementById(sectionState.sectionData[props.data.formControlKey])?.querySelector("[data-active-class]")
        // console.log(currentRadio)
        if (currentRadio) {
          if (sectionState.sectionData[props.data.formControlKey]) {
            let radios = arr[currentRadio.getAttribute("data-active-class")]
            radios?.forEach(radio => {
              radio.classList.remove("active")
            })
            currentRadio.classList.add("active")
          }
        }
      }
      // else{
      //   setConditionState(prev => {
      //     return ({
      //       ...prev,
      //       [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
      //     })
      //   })
      // }
    }
  }, [sectionState.sectionData[props.data.formControlKey], options[props.data.formControlKey]])

  useEffect(() => {
    let temp = journeyState.journeySteps
    let tempPageIndexToChange
    let tempSectionIndexToChange
    let tempComponentGroupIndexToChange
    let tempComponentIndexToChange
    if (props.journeyIdFromStrapi === "titaniumPlusJourney") {
      tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageTitaniumPlusCalculateFundValue")
      tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "CFSectionInvestmentDetails")
      tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "CFPaymentFrequency")
      tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "CFPaymentFrequency")
      if(sectionState.sectionData[props.data.formControlKey] === "ULTPF3" || sectionState.sectionData[props.data.formControlKey] === "ULTPF4"){
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "premiumFrequency_withoutSinglePremium"
      }
      else{
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "premiumFrequency"
      }
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
   }
  }, [sectionState.sectionData["InvestmentPlanOption"]])

  useEffect(() => {
    let optionsFromStrapi = props.data.radioComponent
    if (props.sectionId === "sectionFlexiEdgeCustomizeYourPlan"
      && props.data.formControlKey === "FlexiCPPlanOption" || props.data.formControlKey === "guaranteedFortunePlanOption" ) {
      let pt = conditionState["PageFlexiEdgeCalculatePremium.sectionFlexiEdgeCustomizeYourPlan.FlexiCPPolicyTerm"]
      let ppt = conditionState["PageFlexiEdgeCalculatePremium.sectionFlexiEdgeCustomizeYourPlan.FlexiCPPremiumPaymentTerm"]
      if (pt && ppt) {
        let optionValues = journeyState.optionValues
        let newOptions = optionsFromStrapi.filter(option => {
          if (optionValues[option.value]
            && optionValues[option.value].ptValues?.[pt]
            && optionValues[option.value].pptValues?.[pt]?.[ppt]) {
            let modifiedOption = option
            modifiedOption.checked = false
            return modifiedOption
          }
        })
        if (newOptions.length >= 1) {
          if (sectionState.sectionData[props.data.formControlKey]) {
            let indexTobeChanged = newOptions.findIndex(element => element.value === sectionState.sectionData[props.data.formControlKey])
            if (indexTobeChanged !== -1) {
              newOptions[indexTobeChanged].checked = true
            } else {
              newOptions[0].checked = true
            }

            if (sectionState.sectionId === props.sectionId) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value,
                  },
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: props.sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value,
                  },
                }
              })
            }
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value,
              }
            })
            props.saveApplicationAndCallBi("FlexiCPPlanOption", indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value)
          } else {
            newOptions[0].checked = true
            if (sectionState.sectionId === props.sectionId) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: newOptions[0].value,
                  },
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: props.sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: newOptions[0].value,
                  },
                }
              })

            }
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: newOptions[0].value,
              }
            })
            props.saveApplicationAndCallBi("FlexiCPPlanOption", newOptions[0].value)
          }

        } else {
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
            }
          })
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: ""
              }
            }
          })
        }
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: newOptions
          })
        })
      } else {
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: optionsFromStrapi
          })
        })
        if (!sectionState.sectionData[props.data.formControlKey]) {
          optionsFromStrapi.map(element => {
            if (element.checked) {
              if (sectionState.sectionId === props.sectionId) {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: element.value,
                    },
                  }
                })
              } else {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionId: props.sectionId,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: element.value,
                    },
                  }
                })
              }
              setConditionState(prev => {
                return {
                  ...prev,
                  [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: element.value,
                }
              })
            }
          })
        } else {
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
            }
          })
        }
        return
      }
    } else {
      setOptions(prev => {
        return ({
          ...prev,
          [props.data.formControlKey]: optionsFromStrapi
        })
      })
      if (!sectionState.sectionData[props.data.formControlKey]) {
        optionsFromStrapi.map(element => {
          if (element.checked) {
            if (sectionState.sectionId === props.sectionId) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: element.value,
                  },
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: props.sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: element.value,
                  },
                }
              })
            }
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: element.value,
              }
            })
          }
        })
      } else {
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
          }
        })
      }
      return
    }
  }, [conditionState["PageFlexiEdgeCalculatePremium.sectionFlexiEdgeCustomizeYourPlan.FlexiCPPolicyTerm"], conditionState["PageFlexiEdgeCalculatePremium.sectionFlexiEdgeCustomizeYourPlan.FlexiCPPremiumPaymentTerm"], journeyState.optionValues])
  
  useEffect(() => {
    let temp = journeyState.journeySteps
    if (props.journeyIdFromStrapi === "FutureDollarGiftCityJourney") {
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFutureDollarGiftCityCalculateFundValue")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "FutureDollarGiftCityInvestmentDetailsSection")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "FutureDollarPaymentFrequency")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "FutureDollarPaymentFrequency")
      if(sectionState.sectionData[props.data.formControlKey] === "ULAWF3" || sectionState.sectionData[props.data.formControlKey] === "ULAWF4"){
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "premiumFrequency_FutureDollar_without_singlePremium"
      }
      else{
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "premiumFrequency_FutureDollar"
      }
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
      }
    })
  }, [sectionState.sectionData["FutureDollarInvestmentPlanOption"]])

  useEffect(() => {
    let optionsFromStrapi = props.data.radioComponent
    if(props.sectionId === "SectionInvest4GInvestmentDetails" 
    && props.data.formControlKey === "Invest4gInvestmentPlanOption"){
      let laAndPropSame = conditionState["PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.GOPAslifetobeAssuredandProposer"]
      if(laAndPropSame === "N"){
        let optionValues = optionsFromStrapi.slice(0,2)
        let newOptions = optionValues
        if(newOptions.length >= 1){
          if(sectionState.sectionData[props.data.formControlKey]){
            let indexTobeChanged = newOptions.findIndex(element => element.value === sectionState.sectionData[props.data.formControlKey])
            if(indexTobeChanged !== -1){
              newOptions[indexTobeChanged].checked = true
            }else{
              newOptions[0].checked = true
            }

            if (sectionState.sectionId === props.sectionId) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value,
                  },
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: props.sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value,
                  },
                }
              })
            }
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value,
              }
            })
            props.saveApplicationAndCallBi("Invest4gInvestmentPlanOption", indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value)
          }else{
            newOptions[0].checked = true
            if (sectionState.sectionId === props.sectionId) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: newOptions[0].value,
                  },
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: props.sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: newOptions[0].value,
                  },
                }
              })
              
            }
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: newOptions[0].value,
              }
            })
            props.saveApplicationAndCallBi("Invest4gInvestmentPlanOption", newOptions[0].value)
          }

        }else{
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
            }
          })
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: ""
              }
            }
          })
        }
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: newOptions
          })
        })
      }else{
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: optionsFromStrapi
          })
        })
        if (!sectionState.sectionData[props.data.formControlKey]) {
          optionsFromStrapi.map(element => {
            if (element.checked) {
              if (sectionState.sectionId === props.sectionId) {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: element.value,
                    },
                  }
                })
              } else {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionId: props.sectionId,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: element.value,
                    },
                  }
                })
              }
              setConditionState(prev => {
                return {
                  ...prev,
                  [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: element.value,
                }
              })
            }
          })
        }else{
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
            }
          })
        }
        return 
      }
    }else{
      setOptions(prev => {
        return ({
          ...prev,
          [props.data.formControlKey]: optionsFromStrapi
        })
      })
      if (!sectionState.sectionData[props.data.formControlKey]) {
        optionsFromStrapi.map(element => {
          if (element.checked) {
            if (sectionState.sectionId === props.sectionId) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: element.value,
                  },
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: props.sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: element.value,
                  },
                }
              })
            }
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: element.value,
              }
            })
          }
        })
      }else{
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
          }
        })
      }
      return 
    }
  }, [conditionState["PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.GOPAslifetobeAssuredandProposer"], journeyState.optionValues])

  useEffect(() => {
    let optionsFromStrapi = props.data.radioComponent
    let planOptionList = []
    if(props.sectionId === "SectionInvest4GInvestmentDetails" 
    && props.data.formControlKey === "Invest4gInvestmentPlanOption"){
      let laAndPropSame = conditionState["PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.GOPAslifetobeAssuredandProposer"]
      if(journeyState?.planOptionList){
        optionsFromStrapi?.forEach(element => {
          console.log(element, optionsFromStrapi[element])
          Object.keys(journeyState.planOptionList).forEach(optionList => {
            if(optionList == element.value){
              planOptionList.push(element)
              return
            }
          })
        })
        let newOptions = planOptionList
        if(newOptions.length >= 1){
          if(sectionState.sectionData[props.data.formControlKey]){
            let indexTobeChanged = newOptions.findIndex(element => element.value === sectionState.sectionData[props.data.formControlKey])
            if(indexTobeChanged !== -1){
              newOptions[indexTobeChanged].checked = true
            }else{
              newOptions[0].checked = true
            }

            if (sectionState.sectionId === props.sectionId) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value,
                  },
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: props.sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value,
                  },
                }
              })
            }
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value,
              }
            })
            props.saveApplicationAndCallBi("Invest4gInvestmentPlanOption", indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value)
          }else{
            newOptions[0].checked = true
            if (sectionState.sectionId === props.sectionId) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: newOptions[0].value,
                  },
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: props.sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: newOptions[0].value,
                  },
                }
              })
              
            }
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: newOptions[0].value,
              }
            })
            props.saveApplicationAndCallBi("Invest4gInvestmentPlanOption", newOptions[0].value)
          }

        }else{
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
            }
          })
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: ""
              }
            }
          })
        }
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: newOptions
          })
        })
      }else{
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: optionsFromStrapi
          })
        })
        if (!sectionState.sectionData[props.data.formControlKey]) {
          optionsFromStrapi.map(element => {
            if (element.checked) {
              if (sectionState.sectionId === props.sectionId) {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: element.value,
                    },
                  }
                })
              } else {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionId: props.sectionId,
                    sectionData: {
                      ...prev.sectionData,
                      [props.data.formControlKey]: element.value,
                    },
                  }
                })
              }
              setConditionState(prev => {
                return {
                  ...prev,
                  [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: element.value,
                }
              })
            }
          })
        }else{
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
            }
          })
        }
        return 
      }
      if(laAndPropSame === "N"){
        let optionValues = optionsFromStrapi.slice(0,2)
        let newOptions = optionValues
        if(newOptions.length >= 1){
          if(sectionState.sectionData[props.data.formControlKey]){
            let indexTobeChanged = newOptions.findIndex(element => element.value === sectionState.sectionData[props.data.formControlKey])
            if(indexTobeChanged !== -1){
              newOptions[indexTobeChanged].checked = true
            }else{
              newOptions[0].checked = true
            }

            if (sectionState.sectionId === props.sectionId) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value,
                  },
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: props.sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value,
                  },
                }
              })
            }
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value,
              }
            })
            props.saveApplicationAndCallBi("Invest4gInvestmentPlanOption", indexTobeChanged === -1 ? newOptions[0].value : newOptions[indexTobeChanged].value)
          }else{
            newOptions[0].checked = true
            if (sectionState.sectionId === props.sectionId) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: newOptions[0].value,
                  },
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: props.sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: newOptions[0].value,
                  },
                }
              })
              
            }
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: newOptions[0].value,
              }
            })
            props.saveApplicationAndCallBi("Invest4gInvestmentPlanOption", newOptions[0].value)
          }

        }else{
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
            }
          })
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: ""
              }
            }
          })
        }
        setOptions(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: newOptions
          })
        })
      }
    }
  }, [journeyState?.planOptionList])

  const createCardSet = () => {
    let cardContainers = document.querySelectorAll(".radio-card-container")

    cardContainers.forEach(cardContainer => {
      cardContainer.querySelectorAll("[data-active-class]").forEach(el => {
        let dataActiveClass = el.getAttribute("data-active-class")
        if (arr[dataActiveClass]) {
          arr[dataActiveClass] = [...arr[dataActiveClass], el]
        } else {
          arr[dataActiveClass] = [el]
        }
      })
    })
  }
  createCardSet()

  const handleActiveTab = ({ target }, value) => {
    if (target.getAttribute("data-active-tab")) {
      Array.from(target.parentElement.parentElement.children).forEach(el => {
        el.classList.remove("active-tab")
      })
      target.parentElement.classList.add("active-tab")
      setActiveTab(value)
    }
  }

  const handleEnter = (event1, event2, isCard) => {
    if (event1.key == 'Enter') {
      handleChange(event2, isCard)
    }
  }
  const handleChange = ({ target }, isCard, e) => {
    // e.preventDefault()
    // console.log("inside ", target)
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
      }
    })

    props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
    // if(!selectors.includes(e.target.id ?? '')){
    // }

    // if (target.value && isCard) {
    //   // console.log(target.value)
    //   // console.log(target.value);
    //   // smoke-white-clr
    //   // console.log(target.parentElement.parentElement.parentElement)

    //   // radio-cards by Id
    //   let currentRadio = document
    //     .getElementById(target.value)
    //     .querySelector("[data-active-class]")
    //   // console.log(currentRadio)
    //   // let parent = currentRadio.parentElement.querySelectorAll(".radio-card")

    //   // removing other active class
    //   let radios = arr[currentRadio.getAttribute("data-active-class")]
    //   radios?.forEach(radio => {
    //     radio.classList.remove("active")
    //   })

    //   // activate radio Radio
    //   currentRadio.classList.add("active")
    // }

    // console.log(sectionState, "section state")
    // console.log(conditionState, "condition state")
  }


  const handleChangeSimpleRadio = ({ target }, isCard) => {
    // console.log("inside ", target)
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
      }
    })

    if (!selectors.includes(target.id ?? '')) {
      props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
    }

  }

  let renderOptions = options[props.data.formControlKey]
  if (props.data.formControlKey === "FutureDollarInvestmentPlanOption" && conditionState["PageFutureDollarGiftCityCalculateFundValue.FutureDollarGiftCityPersonelDetailsSection.CFislifetobeAssuredandProposer"] === "N"){
    renderOptions = renderOptions?.slice(0,1)
  }

  return (renderOptions && renderOptions.length >= 1 ?

    <div className={`field ${props.elementClass}`} key={props.sectionId + props.indexForKey}>
      <style>
        {`
        .radio-tab {
          display: flex;
          justify-content:space-evenly;
          margin-bottom:2rem;
          border:1px solid black;
        }
        .radio-tab > *{
          color:black;
          background:transparent;
          padding:0;
          flex:1;
          padding: 4px 0;

        }
        .new-heading-font {
          text-align: left;
          font-size: 22px !important;
          font-weight: 400;
        }

        .radio-tab p{
          margin:0;
          
        }

        .active-tab{
          background-color: ${props.channel === "A" || props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#000000" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"};
          background-color: var(--lumiq-secondary);
          color:white
        }
        .card-label {
          height:3rem;
          text-align:center;
          font-weight:bold;
        }
        
        `}
      </style>
      {radioCardFormControlKey.includes(props.data.formControlKey) ? (
        <>
          <p className="text-left plan-heading new-heading-font">
            {lineCapital(getValueFromJourney(
              journeyState.lookup.label,
              props.data.label
            )) || props.data.label}
          </p>

          {carouselFormControlKey.includes(props.data.formControlKey) ? (
            <div className="row radio-card-container">
              {/* <Swiper
                navigation={true}
                autoplay={true}
                breakpoints={breakpoints(props.data.radioComponent?.length ?? 0)}
              > */}
              {renderOptions && renderOptions.length >= 1 && renderOptions.map((element, i) => {
                return (
                  // <SwiperSlide>
                  <RadioContainer channel={props.channel} className={`${element.class}`} >
                    <div >
                      <label className="width" onKeyPress={(e) => handleEnter(e, { target: { value: element.value } }, true)} tabIndex="0">
                        {/* <p className="radio-label" >{ element.label  }</p> */}
                        <input
                          type={element.type}
                          checked={sectionState.sectionData[props.data.formControlKey]
                            ? sectionState.sectionData[
                            props.data.formControlKey
                            ] === element.value
                            : element.checked
                          }
                          name={element.name}
                          value={element.value}
                          hidden
                        />
                          <div data-active-class="smoke-white-clr" className={`provider card ${(props.data.formControlKey === "Invest4gInvestmentPlanOption")?"card-invest4g":(props.data.formControlKey === "guaranteedFortunePlanOption")?"card-guaranteedFurtunePlan":""}`} >
                            <div className="checked" aria-hidden="true" onClick={(e) => handleChange({ target: { value: element.value } }, true, e)}  >
                              <FaCheck />
                            </div>
                            <div className="icon-container-1 icon-container" aria-hidden="true" onClick={(e) => handleChange({ target: { value: element.value } }, true, e)} >
                              <span>
                                <div className="hero-icon" dangerouslySetInnerHTML={{ __html: element.iconHTML }}>
                                </div>
                              </span>
                            </div>
                            <p className="card-title" >{lineCapital(getValueFromJourney(
                              journeyState.lookup.label,
                              element.label
                            )) || element.label}</p>
                            <span style={{
                              fontSize: '1.2rem'
                            }} >
                              {
                                (props.data.formControlKey == "CPCustomizePlanQuestionOne" || props.data.formControlKey === "iSelect360CPCustomizePlanQuestionOne" || props.data.formControlKey === "InvestmentPlanOption" || props.data.formControlKey === "FutureDollarInvestmentPlanOption" || props.data.formControlKey === "Invest4gInvestmentPlanOption"||props.data.formControlKey === "guaranteedFortunePlanOption" ) ?
                                  <div className="readMoreContainer" >
                                    <ComponentReadMore html={element.html} index={i} style={{ color: "inherit" }} />
                                  </div>

                                  : (props.data.formControlKey === "FlexiCPPlanOption") ?
                                    <>
                                      {Parser(element.html)}
                                    </>
                                    : null
                              }
                            </span>
                          </div>
                      </label>
                    </div>
                  </RadioContainer>
                  // </SwiperSlide>
                )
              })}
              {/* </Swiper> */}
            </div>
          ) : (
            <div className="row radio-card-container ">
              {tabFormControlKey.includes(props.data.formControlKey) ? (
                <div className="radio-tab hidden-lg hidden-md hidden-sm ">
                  {renderOptions && renderOptions.length >= 1 && renderOptions.map((el, i) => {
                    if (el.label) {
                      return (
                        <div
                          className={`${props.data.radioComponent[0].name == el.name
                            ? "active-tab"
                            : ""
                            }`}
                        >
                          <p
                            data-active-tab={el.value}
                            aria-hidden="true"
                            onClick={e => handleActiveTab(e, el.name)}
                            className="text-center"
                            style={{ fontSize: "1.5rem" }}
                          >
                            {lineCapital(getValueFromJourney(
                              journeyState.lookup.label,
                              el.label
                            )) || el.label}
                          </p>
                        </div>
                      )
                    }
                  })}
                </div>
              ) : null}
              {renderOptions && renderOptions.length >= 1 && renderOptions.map((element, i) => {
                return (
                  <div
                    className={`radio-card ${element.class}`}
                    aria-hidden="true"
                    key={i}
                    name={element.name}
                    id={element.value}
                    checked={
                      sectionState.sectionData[props.data.formControlKey]
                        ? sectionState.sectionData[
                        props.data.formControlKey
                        ] === element.value
                        : element.checked
                    }
                    onClick={e =>
                      handleChange({ target: { value: element.value } }, true, e)
                    }
                  >
                    {tabFormControlKey.includes(props.data.formControlKey) ? (
                      <p className="card-label text-left plan-heading new-heading-font hidden-xs">
                        {lineCapital(getValueFromJourney(
                          journeyState.lookup.label,
                          element.label
                        )) || element.label}
                      </p>
                    ) : null}
                    {tabFormControlKey.includes(props.data.formControlKey) ? (
                      <div
                        dangerouslySetInnerHTML={{ __html: element.html }}
                        className={activeTab == element.name ? "" : "hidden-xs"}
                      />
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: element.html }} />
                    )}
                  </div>
                )
              })}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="form-group">
            {props.data.formControlKey === "CPCustomizePlanQuestionThree" && console.log(options, sectionState.sectionData[props.data.formControlKey], conditionState, "effrfgrg")}
            {renderOptions && renderOptions.length >= 1 &&
              <div className="radio-section-design">
                <p>{lineCapital(getValueFromJourney(
                  journeyState.lookup.label,
                  props.data.label
                )) || props.data.label}

                </p>
              </div>
            }
            {renderOptions && renderOptions.length >= 1 && renderOptions.map((element, i) => {
              return (
                <div className="radio-line radio-design" key={i}>
                  <label className="customradio">
                    <span className="radiotextsty inp-label">{lineCapital(getValueFromJourney(
                      journeyState.lookup.label,
                      element.label
                    )) || element.label}
                      {element.tooltip &&
                        <span style={{ marginLeft: "10px" }} className="tooltip-col text-tool-tip-design existing-tool-tip">
                          <div className="tool">i</div>
                          <span className="tooltiptext4 tooltiptext5 tooltiptext4-align-list " style={{ width: "22rem", height: "fit-content", top: "auto", pointerEvents: "none" }}>
                            {Parser(element.tooltip)}
                          </span>
                        </span>
                      }
                    </span>
                    <input
                      type={element.type}
                      name={element.name}
                      id={element.value}
                      value={element.value}
                      checked={
                        sectionState.sectionData[props.data.formControlKey]
                          ? sectionState.sectionData[
                          props.data.formControlKey
                          ] === element.value
                          : element.checked
                      }
                      onChange={handleChangeSimpleRadio}
                    />
                    <span className="provider checkmark" tabIndex="0" onKeyPress={(e) => handleEnter(e, { target: { value: element.value } }, false)} > </span>
                  </label>
                </div>
              )
            })}
          </div>
        </>
      )}
    </div>
    :
    <>
    </>
  )
}
